import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import { Form, Modal, ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import man from "../assets/images/dashboard/profile.png";
import CustomizerContext from "../_helper/Customizer";
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import config from '../config';
import configDB from '../Config/ThemeConfig';
import CryptoJS from 'crypto-js';
import './SigninModern.css';

const Signin = ({ selected }) => {
  const { t } = useTranslation();
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [sentEmail, setSentEmail] = useState(false);
  const [verifyOtp, setVerifyOtp] = useState(false);
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(localStorage.getItem("loginName"));
  const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [resetToken, setResetToken] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    localStorage.setItem("profileURL", man);
    localStorage.setItem("Name", '');
  }, [value, name]);

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    const savedPassword = localStorage.getItem("rememberedPassword");

    if (savedUsername && savedPassword) {
      setUserName(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);


  const loginAuth = async (e) => {
    e.preventDefault();
    const encryptedPassword = CryptoJS.AES.encrypt(password, 'S7h^k9Lz*R!8rL1uNb#X@zPQ5uT3gBsH').toString();
    axios.post(`${config.hostname}/auth/login`, { username, password: encryptedPassword })
      .then(response => {

        if (rememberMe) {
          localStorage.setItem("rememberedUsername", username);
          localStorage.setItem("rememberedPassword", password);
        } else {
          localStorage.removeItem("rememberedUsername");
          localStorage.removeItem("rememberedPassword");
        }

        localStorage.setItem("login", true);
        localStorage.setItem("sessiontoken", response.data.token);
        // Persist the 7-day refresh token the API issues so the axios
        // interceptors can silently renew the 15-min access token. Without this
        // every session hard-expired ~15 min after login.
        if (response.data.refresh_token) {
          localStorage.setItem("refresh_token", response.data.refresh_token);
        }
        localStorage.setItem("usertype", response.data.user_role);
        localStorage.setItem("usertypeId", response.data.user_type_id);
        localStorage.setItem("concessionaireId", response.data.user_concessionaire_id);
        localStorage.setItem("concessionaireName", response.data.user_concessionaire_name);
        localStorage.setItem("loginId", response.data.user_id);
        localStorage.setItem("loginName", response.data.first_name);
        localStorage.setItem("loginUsername", username);
        localStorage.setItem("tenantId", response.data.user_tenant_id);
        localStorage.setItem("propertyAccess", response.data.property_id);
        localStorage.setItem("dataMode", response.data.data_mode);
        localStorage.setItem("auditRequired", response.data.audit_required ? "true" : "false");
        localStorage.setItem("auditTolerance", response.data.audit_tolerance ?? "0");
        const userTypeId = response.data.user_type_id;
        const token = localStorage.getItem("sessiontoken");
        const configheader = {
          headers: {
            Authorization: `${token}`
          }
        };

        if (response.data.user_role === "admin") {
          localStorage.setItem("accessDashboard", "1")
          localStorage.setItem("accessAnalytics", "1")
          localStorage.setItem("accessReports", "1")
          localStorage.setItem("accessRevenueReports", "1")
          localStorage.setItem("accessDataGrid", "1")
          localStorage.setItem("accessGeneralSettings", "1")
          localStorage.setItem("manageGeneralSettings", "1")
          localStorage.setItem("accessTenants", "1")
          localStorage.setItem("manageTenants", "1")
          localStorage.setItem("manageConfigurations", "1")
          localStorage.setItem("manageUsers", "1")
          localStorage.setItem("manageUserProfile", "1")
          localStorage.setItem("accessLogs", "1")
          localStorage.setItem("manageScheduleReports", "1")
          localStorage.setItem("tenantPortalManage", "1")
          localStorage.setItem("manageLeaseDetails", "1")
          localStorage.setItem("accessLicenses", "1")
          localStorage.setItem("manageLicenses", "1")
          localStorage.setItem("accessHealthCheckup", "0") // admins don't get Live Health Checkup
          history(`${process.env.PUBLIC_URL}/v3/spatial`);

        }
        else if (response.data.user_role === "sadmin") {
          history(`${process.env.PUBLIC_URL}/controlpanel/dashboard/default/${layoutURL}`)
        }
        else if (response.data.user_role === "tenant") {
          history(`${process.env.PUBLIC_URL}/tenant/home/${layoutURL}`)
        }
        else if (response.data.user_role === "Backend User") {
          localStorage.setItem("dataDeletePermission", response.data.data_delete_permission)
          localStorage.setItem("accessLicenses", "1")
          localStorage.setItem("manageLicenses", "1")
          history(`${process.env.PUBLIC_URL}/admin/home/${layoutURL}`)
        }
        else {
          axios.post(`${config.hostname}/userpermissions/getpermissionbyusertype`, { user_type_id: userTypeId }, configheader)
            .then((response) => {
              localStorage.setItem("accessDashboard", response.data[0].access_dashboard)
              localStorage.setItem("accessAnalytics", response.data[0].access_analytics)
              localStorage.setItem("accessReports", response.data[0].access_report)
              localStorage.setItem("accessRevenueReports", response.data[0].revenue_share_reports)
              localStorage.setItem("accessDataGrid", response.data[0].access_data_grid)
              localStorage.setItem("accessGeneralSettings", response.data[0].acess_general_settings)
              localStorage.setItem("manageGeneralSettings", response.data[0].manage_general_settings)
              localStorage.setItem("accessTenants", response.data[0].access_tenants)
              localStorage.setItem("manageTenants", response.data[0].manage_tenants)
              localStorage.setItem("manageConfigurations", response.data[0].manage_configurations)
              localStorage.setItem("manageUsers", response.data[0].manage_users)
              localStorage.setItem("manageUserProfile", response.data[0].manage_user_profile)
              localStorage.setItem("accessLogs", response.data[0].access_logs)
              localStorage.setItem("manageScheduleReports", response.data[0].manage_schedule_reports)
              localStorage.setItem("tenantPortalManage", response.data[0].manual_portal_access)
              localStorage.setItem("manageLeaseDetails", response.data[0].manage_lease_details)
              localStorage.setItem("accessLicenses", response.data[0].access_licenses || 0)
              localStorage.setItem("manageLicenses", response.data[0].manage_licenses || 0)
              localStorage.setItem("accessHealthCheckup", response.data[0].access_health_checkup || 0)

              history(`${process.env.PUBLIC_URL}/v3/spatial`);
            })
            .catch((error) => {
              console.log(error);
              toast.error(t('Error fetching permissions'));
            });

        }
        setName(response.data.name);
      })
      .catch((error) => {
        console.log(error);
        toast.error('Error');
      });

  };

  const handleEmailClick = async (e) => {
    e.preventDefault();
    axios.post(`${config.hostname}/users/sendotp`, { email })
      .then((response) => {
        if (response.data === 'Email not found') {
          toast.error(response.data)
        }
        setSentEmail(true)
        setVerifyOtp(false)
      })
      .catch((error) => {
        console.log(error);
        toast.error('Error');
      });

  }

  const handleVerifyOTP = async (e) => {

    e.preventDefault();

    try {

      const response = await axios.post(
        `${config.hostname}/users/verifyotp`,
        {
          username: email,
          otp
        }
      );

      if (response.data.resetToken) {

        setResetToken(response.data.resetToken);
        setVerifyOtp(true);

        toast.success(t('OTP verified successfully'));

      } else {

        toast.error(t('OTP verification failed'));

      }

    } catch (error) {

      toast.error(t('Invalid OTP'));

    }

  };

  const handleResetPassword = async (e) => {

    e.preventDefault();

    try {

      await axios.post(
        `${config.hostname}/users/resetpassword`,
        {
          username: email,
          newPassword,
          resetToken
        }
      );

      toast.success(t('Password reset successfully'));

      setSentEmail(false);
      setVerifyOtp(false);

      setOtp('');
      setEmail('');
      setNewPassword('');
      setResetToken('');

      toggleModal();

    } catch (error) {

      toast.error(t('Password reset failed'));

    }

  };


  return (
    <Fragment>
      <div className="modern-login-page">
        {/* ── Left branding panel ── */}
        <div className="modern-login-brand">
          <div className="brand-content">
            <div className="brand-logo-area">
              <svg width="240" height="72" viewBox="0 0 200 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="28" width="9" height="24" rx="2" fill="rgba(255,255,255,0.5)"/>
                <rect x="17" y="16" width="9" height="36" rx="2" fill="rgba(255,255,255,0.7)"/>
                <rect x="30" y="6" width="9" height="46" rx="2" fill="white"/>
                <text x="50" y="40" fontFamily="Inter, system-ui, sans-serif" fontWeight="700" fontSize="34" fill="white">EGoal</text>
              </svg>
              <div className="brand-tagline">DATA-DRIVEN</div>
            </div>

            {/* Analytics illustration */}
            <div className="brand-illustration">
              <img
                src={require('../assets/images/login/loginpage.png')}
                alt="EGoal Analytics Platform"
                className="illustration-img"
              />
            </div>
          </div>

          <div className="brand-copyright">&copy; 2025 EGoal &middot; All rights reserved</div>
        </div>

        {/* ── Right form panel ── */}
        <div className="modern-login-form-panel">
          <div className="modern-login-container">
            <h1 className="modern-welcome-title">{t('Welcome back')}</h1>
            <p className="modern-welcome-sub">{t('Sign in to your EGoal account')}</p>

            <Form className="modern-login-form" onSubmit={(e) => e.preventDefault()}>
              <div className="modern-field">
                <label htmlFor="modern-username">{t('Username')}</label>
                <div className="modern-input-wrap">
                  <span className="modern-input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </span>
                  <input
                    type="text"
                    id="modern-username"
                    ref={inputRef}
                    className="modern-input"
                    placeholder={t('Enter your username')}
                    onChange={(e) => setUserName(e.target.value)}
                    value={username}
                  />
                </div>
              </div>

              <div className="modern-field">
                <label htmlFor="modern-password">{t('Password')}</label>
                <div className="modern-input-wrap">
                  <span className="modern-input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                  </span>
                  <input
                    type={togglePassword ? "text" : "password"}
                    id="modern-password"
                    className="modern-input"
                    placeholder={t('Enter your password')}
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        if (password === 'egoal@1') {
                          toggleModal();
                          localStorage.setItem("showGuideTour", "1");
                        } else {
                          localStorage.setItem("showGuideTour", "0");
                          loginAuth(e);
                        }
                      }
                    }}
                  />
                  <button
                    type="button"
                    className="modern-toggle-pw"
                    onClick={() => setTogglePassword(!togglePassword)}
                  >
                    {togglePassword ? t('Hide') : t('Show')}
                  </button>
                </div>
              </div>

              <div className="modern-options-row">
                <label className="modern-remember">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span>{t('Remember me')}</span>
                </label>
                <a className="modern-forgot-link" onClick={toggleModal}>
                  {t('Forgot Password?')}
                </a>
              </div>

              <button
                type="button"
                className="modern-btn-signin"
                onClick={(e) => {
                  if (password === 'egoal@1') {
                    toggleModal();
                    localStorage.setItem("showGuideTour", "1");
                  } else {
                    localStorage.setItem("showGuideTour", "0");
                    loginAuth(e);
                  }
                }}
              >
                {t('Sign In')}
              </button>
            </Form>

            <div className="modern-form-footer">
              EGoal V3 &middot; Retail Intelligence Platform
            </div>

            {/* Reset password modal — modern themed, identical logic */}
            <Modal isOpen={modal} toggle={toggleModal} centered className="eg-reset-modal" contentClassName="eg-reset-content">
              <ModalBody className="eg-reset-body">
                <button type="button" className="eg-reset-close" onClick={toggleModal} aria-label="Close">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
                </button>

                <div className="eg-reset-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </div>

                <h2 className="eg-reset-title">{t('Reset Password')}</h2>
                <p className="eg-reset-sub">{t("Enter your email address and we'll send you an email with instructions to reset your password.")}</p>

                <div className="eg-reset-field">
                  <input
                    className="eg-reset-input"
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t('Enter your email')}
                  />
                </div>
                <button type="button" className="eg-reset-btn" onClick={(e) => handleEmailClick(e)}>
                  {sentEmail === true ? t('Resend OTP') : t('Send OTP')}
                </button>

                {sentEmail === true && (
                  <div className="eg-reset-step">
                    <div className="eg-reset-step-label">{t('Enter OTP')}</div>
                    <div className="eg-reset-field">
                      <input
                        className="eg-reset-input"
                        type="text"
                        id="otp"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder={t('Enter OTP')}
                      />
                    </div>
                    <button type="button" className="eg-reset-btn" onClick={(e) => handleVerifyOTP(e)} disabled={verifyOtp}>
                      {t('Verify OTP')}
                    </button>
                  </div>
                )}

                {verifyOtp === true && (
                  <div className="eg-reset-step">
                    <div className="eg-reset-step-label">{t('Enter New Password')}</div>
                    <div className="eg-reset-field">
                      <input
                        className="eg-reset-input"
                        type="password"
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder={t('Enter New Password')}
                      />
                    </div>
                    <button type="button" className="eg-reset-btn" onClick={(e) => handleResetPassword(e)}>
                      {t('Reset Password')}
                    </button>
                  </div>
                )}
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;
